import { Button } from "primereact/button";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppShell from "../components/AppShell";
import { usePageTitle } from "../components/PageTitle";
import { applyDirection } from "../lib/direction";

export default function NotFound() {
  const { t, i18n } = useTranslation();
  const nav = useNavigate();
  usePageTitle(t("ui.notFoundTitle"));

  useEffect(() => {
    applyDirection(i18n.language);
  }, [i18n.language]);

  return (
    <AppShell width="center">
      <div className="auth-card rise" style={{ textAlign: "center" }}>
        <p
          className="mono"
          style={{
            fontSize: "3.5rem",
            fontWeight: 600,
            lineHeight: 1,
            color: "var(--text-subtle)",
            letterSpacing: "-0.04em",
          }}
        >
          404
        </p>
        <h1 className="auth-card__title" style={{ marginTop: "var(--space-3)" }}>
          {t("ui.notFoundTitle")}
        </h1>
        <p className="auth-card__text">{t("ui.notFoundText")}</p>
        <Button
          label={t("joinTeam.goHome")}
          icon="pi pi-arrow-left"
          className="w-full"
          style={{ marginTop: "var(--space-5)" }}
          onClick={() => nav("/")}
        />
      </div>
    </AppShell>
  );
}
